import React from 'react';
import {connect} from 'react-redux';
import {SEARCHBYTESTKEY, SIMULATE_RESULTS} from 'constants/index';
import './styles.scss';
import SearchByTestKey from 'pages/SearchByTestKey';
import SimulateTestResult from 'pages/SimulateTestResult';

class Tests extends React.Component {
	constructor() {
		super();

		this.state = {
			activeFilter: SEARCHBYTESTKEY,
		};
	}

	render() {
		const {activeFilter} = this.state;
		const {isSuperAdmin} = this.props;

		const testsFilters = [
			SEARCHBYTESTKEY,
			...(isSuperAdmin ? [SIMULATE_RESULTS] : []),
		];

		return (
			<div>
				<div className="lit-test-section-drop-down">
					<div className="lit-dropdown_filter">
						<select
							className="lit-input__field"
							defaultValue={SEARCHBYTESTKEY.id}
							onChange={(e) => {
								this.setState({
									activeFilter: testsFilters.filter(
										(filter) => filter.id === e.target.value
									)[0],
								});
							}}
						>
							{testsFilters.map((userStageFilter) => (
								<option
									key={userStageFilter.id}
									value={userStageFilter.id}
								>
									{userStageFilter.label ||
										userStageFilter.text}
								</option>
							))}
						</select>
					</div>
				</div>

				{activeFilter === SEARCHBYTESTKEY && (
					<div className="lit-search-by-test-key">
						<SearchByTestKey />
					</div>
				)}

				{activeFilter === SIMULATE_RESULTS && isSuperAdmin && (
					<div className="lit-simulate-wrapper">
						<SimulateTestResult />
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentUser} = state;
	return {
		isSuperAdmin: currentUser?.isSuperAdmin || false,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Tests);
